<div class="onboarding-backdrop" role="dialog" aria-modal="true" aria-labelledby="onboarding-progress">
  <div class="onboarding-progress">
    <p id="onboarding-progress" class="onboarding-progress-label">
      {{ 'colimind.onboardingProgress' | translate: { step: progress().step, total: totalSteps, title: (progress().titleKey | translate) } }}
    </p>
    <div class="onboarding-segments" aria-hidden="true">
      @for (i of segments; track i) {
        <span class="onboarding-segment" [class.onboarding-segment--done]="i < progress().done"></span>
      }
    </div>
  </div>

  <div #thread class="onboarding-thread">
    <div class="onboarding-column" role="log" aria-live="polite">
      @for (entry of entries(); track $index) {
        @if (entry.kind === 'user') {
          <div class="onboarding-user">{{ entry.textKey | translate }}</div>
        } @else {
          <div class="onboarding-message">
            <span class="onboarding-avatar"><mat-icon>assistant</mat-icon></span>
            <div class="onboarding-bubble">
              @switch (entry.kind) {
                @case ('step') {
                  @if (entry.step === 0 && userName) {
                    <p class="onboarding-hello">{{ 'colimind.onboardingHello' | translate: { name: userName } }}</p>
                  }
                  <h3 class="onboarding-title">{{ steps[entry.step].titleKey | translate }}</h3>
                  @for (bodyKey of steps[entry.step].bodyKeys; track bodyKey) {
                    <p class="onboarding-body">{{ bodyKey | translate }}</p>
                  }
                  @if (steps[entry.step].noteKey; as noteKey) {
                    <p class="onboarding-note">
                      <mat-icon>warning_amber</mat-icon>
                      {{ noteKey | translate }}
                    </p>
                  }
                }
                @case ('terms') {
                  <h3 class="onboarding-title">{{ 'colimind.onboardingTermsTitle' | translate }}</h3>
                  <p class="onboarding-body">
                    {{ (entry.again ? 'colimind.onboardingTermsAgainBody' : 'colimind.onboardingTermsBody') | translate }}
                  </p>
                  @if (isLast(entry)) {
                    <button
                      type="button"
                      class="onboarding-terms-toggle"
                      [attr.aria-expanded]="termsOpen()"
                      (click)="termsOpen.set(!termsOpen())">
                      {{ (termsOpen() ? 'colimind.onboardingTermsHide' : 'colimind.onboardingTermsShow') | translate }}
                    </button>
                    @if (termsOpen()) {
                      <div class="onboarding-terms-text" tabindex="0">{{ 'colimind.onboardingTermsText' | translate }}</div>
                    }
                    <label class="onboarding-terms-check">
                      <input #focusTarget type="checkbox" [checked]="termsChecked()" (change)="termsChecked.set(!termsChecked())" />
                      <span>{{ 'colimind.onboardingTermsCheck' | translate }}</span>
                    </label>
                  }
                }
                @case ('declined') {
                  <p class="onboarding-body">{{ 'colimind.onboardingTermsDeclined' | translate }}</p>
                }
                @case ('done') {
                  <h3 class="onboarding-title">{{ 'colimind.onboardingDoneTitle' | translate }}</h3>
                  <p class="onboarding-body">{{ 'colimind.onboardingDoneBody' | translate }}</p>
                }
              }
            </div>
          </div>
        }
      }

      @if (typing()) {
        <div class="onboarding-message">
          <span class="onboarding-avatar"><mat-icon>assistant</mat-icon></span>
          <div class="onboarding-typing" [attr.aria-label]="'colimind.onboardingTyping' | translate">
            <span></span><span></span><span></span>
          </div>
        </div>
      }

      @if (last(); as entry) {
        <div class="onboarding-replies">
          @switch (entry.kind) {
            @case ('step') {
              <button #focusTarget type="button" class="onboarding-reply" (click)="next(entry.step)">
                {{ steps[entry.step].replyKey | translate }}
              </button>
            }
            @case ('terms') {
              <button type="button" class="onboarding-reply onboarding-reply--secondary" (click)="declineTerms()">
                {{ 'colimind.onboardingTermsDecline' | translate }}
              </button>
              <button type="button" class="onboarding-reply" [disabled]="!termsChecked()" (click)="acceptTerms()">
                {{ 'colimind.onboardingTermsAccept' | translate }}
              </button>
            }
            @case ('declined') {
              <button #focusTarget type="button" class="onboarding-reply" (click)="reviewTerms()">
                {{ 'colimind.onboardingTermsReview' | translate }}
              </button>
            }
            @case ('done') {
              <button #focusTarget type="button" class="onboarding-reply onboarding-reply--primary" (click)="start()">
                {{ 'colimind.onboardingDoneStart' | translate }}
              </button>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
